/**
 * What apiFetch does with a 200 body that carries an `error` field.
 *
 * Default: such a body is a backend failure (the old debug path answers 200 with `{ error }`), and apiFetch throws an
 * ApiError(500) for it.
 *
 * Opt-in exception (`returnErrorBody`, used by useAiJob only): the body of a FAILED AI job. GET ai-jobs/{id} answers
 * 200 with `{ job_id, status: 'failed', error, error_code, ... }` — that is payload, not a transport failure. Thrown as
 * an ApiError the caller never saw `status: 'failed'`: the cache kept the last 'running' body, the banner and the row
 * buttons kept waiting until the client gave up after 16 minutes, no reason was shown, the cost lines were not
 * refreshed and the poll retried the failed request.
 *
 * Only a job-shaped body (a string `status`) is let through: a bare `{ error }` stays an error either way.
 *
 * Pure JS (like classifyApiError.js) so `node --test` can load it — api.ts itself cannot (import.meta.env).
 *
 * @param {{ error?: unknown, status?: unknown } | null | undefined} json the parsed 200 body
 * @param {boolean} [returnErrorBody] the caller wants a failed-job body back as data
 * @returns {string | null} the message to throw an ApiError(500) with; null = return the body as data
 */
export function embeddedErrorMessage(json, returnErrorBody = false) {
  if (!json || !json.error) return null
  if (returnErrorBody && typeof json.status === 'string') return null
  return String(json.error)
}
